import { Text, withText } from 'preact-i18n';

const PickerHeader = ({
  message = <Text id="text.round_trip_promotion" />,
  discount,
  discountLabel,
  showRoundPromotion,
}) => {
  if (!message || !showRoundPromotion) return null;

  return (
    <div className="udp-picker-header">
      <p className="udp-picker-header__message">{message}</p>
      <strong className="udp-picker-header__discount">
        {!discount ? (
          <div
            className="udp-picker-header__discount-icon"
            role="img"
            aria-label={discountLabel}
          />
        ) : (
          `-${discount}%`
        )}
      </strong>
    </div>
  );
};

export default withText({
  discountLabel: 'text.discount',
})(PickerHeader);
